import React from "react";
import { LetterOfAuthorization, Header, Image, Subheader, InstructionList,InstructionSubList, OwnerAuthority, FontMediumText, SignGurantee, FormInput, AuthorizedOffice, Guildelines, Print , CharityACDetails, Address, LetterWrapper, FontBoldText} from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
let assetOutSG = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();
    }

    renderPrintData = () => {
        return (
<LetterOfAuthorization>
                <Image justifyContent = "flex-start" marginBottom="10px">
                    <img src={logo} alt="vanguard"></img>
                </Image>
                <Header>Delivery instructions for securities</Header>
                <Subheader>Contribution of securities held outside of Vanguard Brokerage Services
                </Subheader>
                <InstructionList>
                    <li>
                        Vanguard Charitable account information
                        <div>Account number: { assetOutSG[0].logAcNum }</div>
                        <div>Account name: { assetOutSG[0].logAcName }</div>
                    </li>
                    <li>
                        Funding instructions
                        <div>These instructions are intended to help you initiate a transfer of assets. You may print these instructions
                            and send them directly to the broker or firm or follow the two steps outlined below. <FontBoldText>Vanguard
                            Charitable will not contact your broker to initiate a transfer.</FontBoldText>
                        </div>
                        <InstructionSubList type="a">
                            <li>
                                Contact the broker or firm holding your securities (detailed in <FontBoldText>Section 3</FontBoldText>).
                            </li>
                            <li>
                                Provide transfer instructions (detailed in <FontBoldText>Section 4</FontBoldText>) in order to authorize the asset transfer.
                            </li>
                            
                        </InstructionSubList>
                        <br />
                        <div>Some brokers may not accept this form and will require you to complete and sign other paperwork. The
                            broker may also require a Medallion signature guarantee. We recommend contacting your broker as soon
                            as possible to determine the requirements of transferring your securities and finalizing your intended
                            contribution.
                        </div>
                    </li>
                    <li>
                        Current broker or firm information
                        <CharityACDetails marginLeft="0px">
                            <div>Name of broker or firm holding securities: {assetOutSG[0].firm} </div>
                            <div>Brokerage account number: {assetOutSG[0].accountNumber}</div>
                        </CharityACDetails>
                        <Address>
                            <div>Street address or P.O. box number:<input type="text"/></div>
                            <div>City:<input type="text"/></div>
                            <div>State:<input type="text"/></div>
                            <div>Zip code:<input type="text"/></div>
                        </Address>
                        <CharityACDetails marginLeft="0px">
                            <div>Contact name: <input type="text"/></div>
                            <div>Daytime phone number: <input type="text"/></div>
                        </CharityACDetails>
                    </li>
                    <li>
                        Instructions to the broker's DTC/Free-delivery department 
                        <div>Please accept these instructions as the authorization to transfer the assets specified below to Vanguard
                            Charitable's brokerage account. <FontBoldText>Securities should be transferred in-kind and are not to be liquidated.</FontBoldText>
                        </div>
                        <br/>
                        <div>Send the securities via DTC to Vanguard Brokerage Services, a division of Vanguard Marketing
                            Corporation, with the client name and account number in the DTC trailer.
                        </div>
                        <br />
                        <div>
                            <FontMediumText>Receiving firm information</FontMediumText>
                            <div>Receiving firm: Vanguard Brokerage Services</div>
                            <div>Vanguard Charitable brokerage account number: 76580331</div>
                            <div>DTC clearing number: 0062</div>
                        </div>
                        <div className="mt-05"><FontBoldText>Further credit to:</FontBoldText> { assetOutSG[0].logAcName } </div>
                        <table className="mt-05 center" border="1">
                            <thead>
                                <tr>
                                    <th>Name of security</th>
                                    <th>Number of shares</th>
                                </tr>
                            </thead>
                            <tbody>
                            {assetOutSG.map((fund) => (
                                <tr>
                                    <td>{fund.fundName}</td>
                                    <td>{fund.shares ? fund.shares : (fund.allShares ? 'All Shares' : fund.shares)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </li>
                    <li>
                        Signatures: This section must be signed by all registered owners/trustees/officers of the assets to be donated.
                        <div className="mt-05">I hereby irrevocably relinquish all rights, title, and interest to the assets specified in Section 4 of this
                            document. I hereby acknowledge that I have read and understand the terms of the transfer of assets I have
                            requested and further acknowledge that the terms of this transfer are binding regardless of any other
                            agreement between Vanguard Charitable and me.
                        </div>
                        <div className="mt-10">
                            <FontBoldText>Signature(s)</FontBoldText> Do not sign until you are in the presence of the person guaranteeing your signature.
                        </div>
                        <OwnerAuthority>
                            <div>Owner A</div>
                            <div>Owner's Name: {(assetOutSG[0].type === "Individual" || assetOutSG[0].type === "Joint") ? assetOutSG[0].name : assetOutSG[0].donorName}</div>
                            <div>
                                <div>
                                    <label>Signature:</label>
                                    <input type="text"></input>
                                </div>
                                <div>
                                    <label>Date(mm-dd-yyyy):</label>
                                    <input type="text"></input>
                                </div>
                            </div>
                        </OwnerAuthority>
                        { assetOutSG[0].type === "Joint" ?
                    <OwnerAuthority>
                        <div>Owner B</div>
                        <div>Owner's Name: {assetOutSG[0].firstName + ' ' +  assetOutSG[0].lastName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    :
                    ''
                    }
                        <SignGurantee>
                            <FontBoldText>Medallion signature guarantee - IF REQUIRED by your brokerage firm</FontBoldText>
                            <div>A notary public cannot provide a signature guarantee.</div>
                            <FormInput>
                                <label>Signature of authorized officer:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Name of institution:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Title:</label>
                                <input type="text"></input>
                            </FormInput>
                            <FormInput>
                                <label>Date:</label>
                                <input type="text"></input>
                            </FormInput>
                            <AuthorizedOffice>
                                <div>
                                    Authorized officer to place stamp here.
                                </div>
                                <div>
                                    This applies to all signatures in Section 5.
                                </div> 
                            </AuthorizedOffice>
                        </SignGurantee>
                    </li>
                    <li>Return information
                        <div>
                            Send this completed original form to the broker or firm listed in Section 3.
                        </div>
                        <div className="mt-05">
                            Contact Vanguard Charitable with any questions at donorservice@vanguardcharitable.org or 888-383-
                            4483.
                        </div>
                    </li>
                </InstructionList>
                <Guildelines>
                    If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                    For more information, view our <a href={assetOutSG[0].envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                    <span>Policies and guidelines</span></a> booklet.
                </Guildelines>
            </LetterOfAuthorization>   

        )
    }

    render() {
        assetOutSG = [];
        assetOutSG = localStorage["assetOutSG"] ? JSON.parse(localStorage["assetOutSG"]) : [];
        return (
            <LetterWrapper> 
            <PrintComponents
               className="i_print"
               trigger={
                 <Print>
                 <StyleLessButton>
                   <IconPadding className="ml2">
                     <img src={printIcon} alt="print" />
                     <DataExportPrint>PRINT</DataExportPrint>
                   </IconPadding>
                 </StyleLessButton>
                 </Print>
               } >
                   {this.renderPrintData()}
               </PrintComponents>
            {this.renderPrintData()}</LetterWrapper>
   );  
                
    }
}

export default ViewContribution;